import { SVGProps } from "react";

export const ExchangeMissingIcon = (props: SVGProps<SVGSVGElement>) => (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16 23C19.866 23 23 19.866 23 16C23 12.134 19.866 9 16 9C12.134 9 9 12.134 9 16C9 19.866 12.134 23 16 23Z"
            stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M16 12.2307V15.9999H18.6923" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"
              stroke-linejoin="round"/>
    </svg>

);
